export const COURSE_CAMPAIGN = '/course_campaign/' as const
export const COURSE_CAMPAIGN_ALL = `${COURSE_CAMPAIGN}all` as const
